import { Button, FlexBox, InputText } from '@dixa/lib-shared-habla';
import { UploadMenu } from 'articleEditor/components/uploadMenu';
import { UseFloatingMenuReturn } from 'articleEditor/hooks/useFloatingMenu';
import {
  findNodePath,
  focusEditor,
  isUrl,
  setNodes,
} from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyEmbedElement } from 'lib-knowledge-document-structure/plateTypes';
import { useState } from 'react';

type EmbedLinkMenu = {
  element: MyEmbedElement;
  floatingLinkMenu: UseFloatingMenuReturn;
};

export function EmbedLinkMenu({
  element,
  floatingLinkMenu,
}: EmbedLinkMenu): JSX.Element {
  if (!floatingLinkMenu.showFloatingMenu) return <></>;

  return (
    <UploadMenu
      floatingProps={{ ...floatingLinkMenu.floatingResult, isOpen: true }}
      getFloatingProps={floatingLinkMenu.getFloatingMenuProps}
    >
      <Embed
        element={element}
        closeLinkMenu={floatingLinkMenu.closeFloatingMenu}
      />
    </UploadMenu>
  );
}

type EmbedProps = {
  element: MyEmbedElement;
  closeLinkMenu: () => void;
};

function Embed({ closeLinkMenu, element }: EmbedProps) {
  const [embedSrc, setEmbedSrc] = useState(element.src ?? '');
  const editor = useMyEditorRef();

  const isUrlValid = isUrl(embedSrc);

  const onEmbedUrl = () => {
    const path = findNodePath(editor, element);
    setNodes(editor, { src: embedSrc }, { at: path });

    // Give the DOM a chance to update
    setTimeout(() => {
      closeLinkMenu();

      focusEditor(editor, editor.selection!);
    }, 50);
  };

  return (
    <FlexBox gap="200" padding="400" alignItems="center">
      <InputText
        placeholder="Embed url"
        value={embedSrc}
        onChange={(e) => setEmbedSrc(e.target.value)}
      />

      <Button
        disabled={!isUrlValid}
        onClick={onEmbedUrl}
        style={{ height: '40px' }}
      >
        Embed
      </Button>
    </FlexBox>
  );
}
